export enum PrintStepGroups {
  PrintAndSign = "Print and sign",
  UploadDocuments = "Upload documents",
}
export enum DocusignStepGroups {
  ConfigureDocuments = "Configure documents",
  UploadDocuments = "Upload documents",
}

export enum DocumentMode {
  Docusign = "docusign",
  Print = "print",
}

export const TAX_FORM_LABEL = `U.S. tax withholding form`;
export const SIGNER_SELECTION_LABEL = `Signer selection`;
export const ADDITIONAL_DOCS_LABEL = `Additional documents`;
export enum Labels {
  AdditionalDocuments = "Additional documents",
}

export enum StepCompletionStatus {
  Uploaded = "UPLOADED",
  Selected = "SELECTED",
  Required = "REQUIRED",
  NewDocumentsRequired = "NEW DOCUMENTS REQUIRED",
}

export enum LpDocumentTypes {
  FormationDocument = "formation_document",
  File = "file",
  IdentityDocument = "identity_document",
  AuditedFinancial = "audited_financial",
  CorporateResolution = "corporate_resolution",
}
// TODO amoeba - audit places this is used and add subs v3 state logic
export enum SubscriptionStatus {
  Canceled = "Canceled",
  Invited = "Invited",
  Started = "Started",
  PendingSignature = "PendingSignature",
  Signed = "Signed",
  IdentityInformationCollected = "IdentityInformationCollected",
  InvestorDiligenceCompleted = "InvestorDiligenceCompleted",
  StaffReview = "StaffReview",
  StaffReviewCompleted = "StaffReviewCompleted",
  Countersigned = "Countersigned",
  Declined = "Declined",
  Accepted = "Accepted",
}
export enum DocusignStatuses {
  Created = "Created",
  Sent = "sent",
  Delivered = "delivered",
}
export enum KycStatus {
  KYC = "KYC",
  NonKYC = "NonKYC",
}

export const POLL_WAIT = 3000;

export const subtitleCorporateResolutionWhenInPrintMode = `Please provide a copy of the Corporate Resolution, Corporate Action, or other legal document that shows the investment has been authorized by the Board of Directors. You may upload this document, or return a copy through the mail with the rest of the subscription package.`;
const kycSubscriberTypeMessage = `To identify the subscribing entity, please upload a formation document, such as the Certification of Formation, Articles of Incorporation, or equivalent (e.g., SS-4 from the IRS).  Note that per our procedures, an operating agreement is not considered sufficient.`;
const kycOtherSubscriberMessage = `To identify the subscribing entity, please provide a formation document, such as the Articles of Association, Articles of Incorporation, Articles of Organization, or Foundation Charter. Note that per our procedures, an operating agreement is not considered sufficient.`;
const printCaseAdditionalMessage = `You may upload this document, or return a copy through the mail with the rest of the subscription package.`;
export const DOCUSIGN_TITLES = {
  CORPORATION: {
    KYC: {
      [LpDocumentTypes.FormationDocument]: kycSubscriberTypeMessage,
      [LpDocumentTypes.CorporateResolution]: `Please provide a copy of the Corporate Resolution, Corporate Action, or other legal document that shows the investment has been authorized by the Board of Directors.`,
    },
    NonKYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide the formation document for the subscribing corporation.`,
      [LpDocumentTypes.CorporateResolution]: `Please provide a copy of the Corporate Resolution, Corporate Action, or other legal document that shows the investment has been authorized by the Board of Directors.`,
    },
  },
  IRA: {
    KYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide a copy of the Summary Plan Description or other formation document that identifies the subscribing benefit plan.`,
    },
    NonKYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide a copy of the Summary Plan Description or other formation document that identifies the subscribing benefit plan.`,
    },
  },
  OTHER: {
    KYC: {
      [LpDocumentTypes.FormationDocument]: kycOtherSubscriberMessage,
      [LpDocumentTypes.AuditedFinancial]: `Please provide a copy of an audit document that shows the subscribing entity’s financials have been independently audited.`,
    },
    NonKYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide a copy of the Articles of Association, Articles of Incorporation, Articles of Organization, Foundation Charter, Bylaws, Operating Agreement, or other formation document that identifies the subscribing entity.`,
      [LpDocumentTypes.AuditedFinancial]: `Please provide a copy of an audit document that shows the subscribing entity’s financials have been independently audited.`,
    },
  },
  PARTNERSHIP: {
    KYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide the Partnership Agreement for the subscribing partnership.`,
    },
    NonKYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide the Partnership Agreement for the subscribing partnership.`,
    },
  },
  TRUST: {
    KYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide a trust document, declaration of trust, or other formation document identifying the subscribing trust and the trustee(s).`,
    },
    NonKYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide a trust document, declaration of trust, or other formation document identifying the subscribing trust and the trustee(s).`,
    },
  },
  LLC: {
    KYC: {
      [LpDocumentTypes.FormationDocument]: kycSubscriberTypeMessage,
      [LpDocumentTypes.CorporateResolution]: `Please provide a copy of the Corporate Resolution, Corporate Action, or other legal document that shows the investment has been authorized by the Board of Directors.`,
    },
    NonKYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide the formation document for the subscribing LLC.`,
      [LpDocumentTypes.CorporateResolution]: `Please provide a copy of the Corporate Resolution, Corporate Action, or other legal document that shows the investment has been authorized by the Board of Directors.`,
    },
  },
  "501c3": {
    KYC: {
      [LpDocumentTypes.FormationDocument]: kycSubscriberTypeMessage,
      [LpDocumentTypes.CorporateResolution]: `Please provide a copy of the Corporate Resolution, Corporate Action, or other legal document that shows the investment has been authorized by the Board of Directors.`,
    },
    NonKYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide the formation document for the subscribing 501(c)(3) organization.`,
      [LpDocumentTypes.CorporateResolution]: `Please provide a copy of the Corporate Resolution, Corporate Action, or other legal document that shows the investment has been authorized by the Board of Directors.`,
    },
  },
};

export const PRINT_TITLES = {
  CORPORATION: {
    KYC: {
      [LpDocumentTypes.FormationDocument]: `${kycSubscriberTypeMessage} ${printCaseAdditionalMessage}`,
    },
    NonKYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide the formation document for the subscribing corporation. ${printCaseAdditionalMessage}`,
    },
  },
  IRA: {
    KYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide a copy of the Summary Plan Description or other formation document that identifies the subscribing benefit plan. ${printCaseAdditionalMessage}`,
    },
    NonKYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide a copy of the Summary Plan Description or other formation document that identifies the subscribing benefit plan. ${printCaseAdditionalMessage}`,
    },
  },
  OTHER: {
    KYC: {
      [LpDocumentTypes.FormationDocument]: `${kycOtherSubscriberMessage} ${printCaseAdditionalMessage}`,
      [LpDocumentTypes.AuditedFinancial]: `Please provide a copy of an audit document that shows the subscribing entity’s financials have been independently audited. ${printCaseAdditionalMessage}`,
    },
    NonKYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide a copy of the Articles of Association, Articles of Incorporation, Articles of Organization, Foundation Charter, Bylaws, Operating Agreement, or other formation document that identifies the subscribing entity. ${printCaseAdditionalMessage}`,
      [LpDocumentTypes.AuditedFinancial]: `Please provide a copy of an audit document that shows the subscribing entity’s financials have been independently audited. ${printCaseAdditionalMessage}`,
    },
  },
  PARTNERSHIP: {
    KYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide the Partnership Agreement for the subscribing partnership. ${printCaseAdditionalMessage}`,
    },
    NonKYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide the Partnership Agreement for the subscribing partnership. ${printCaseAdditionalMessage}`,
    },
  },
  TRUST: {
    KYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide a trust document, declaration of trust, or other formation document identifying the subscribing trust and the trustee(s). ${printCaseAdditionalMessage}`,
    },
    NonKYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide a trust document, declaration of trust, or other formation document identifying the subscribing trust and the trustee(s). ${printCaseAdditionalMessage}`,
    },
  },
  LLC: {
    KYC: {
      [LpDocumentTypes.FormationDocument]: `${kycSubscriberTypeMessage} ${printCaseAdditionalMessage}`,
      [LpDocumentTypes.CorporateResolution]: subtitleCorporateResolutionWhenInPrintMode,
    },
    NonKYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide the formation document for the subscribing LLC. ${printCaseAdditionalMessage}`,
      [LpDocumentTypes.CorporateResolution]: subtitleCorporateResolutionWhenInPrintMode,
    },
  },
  "501c3": {
    KYC: {
      [LpDocumentTypes.FormationDocument]: `${kycSubscriberTypeMessage} ${printCaseAdditionalMessage}`,
      [LpDocumentTypes.CorporateResolution]: subtitleCorporateResolutionWhenInPrintMode,
    },
    NonKYC: {
      [LpDocumentTypes.FormationDocument]: `Please provide the formation document for the subscribing 501(c)(3) organization. ${printCaseAdditionalMessage}`,
      [LpDocumentTypes.CorporateResolution]: subtitleCorporateResolutionWhenInPrintMode,
    },
  },
};

export const FILE_UPLOAD_URL = "/file_upload";

export const ENVELOPE_SENT_STATUS = new Set([
  DocusignStatuses.Sent,
  DocusignStatuses.Delivered,
]);

export const ERROR_CODE_HOURLY_LIMIT_EXCEEDED = "HOURLY_APIINVOCATION_LIMIT_EXCEEDED";

export const ERROR_CODE_REQUEST_TOO_LARGE = "REQUEST_ENTITY_TOO_LARGE";
export const ERROR_CODE_EMAIL_RESERVED = "EMAIL_IS_RESERVED";
export const ERROR_CODE_INVALID_RECIPIENT = "UNKNOWN_ENVELOPE_RECIPIENT";

export const FILE_TOO_LARGE_UI_ERROR_MESSAGE =
  "Combined size of all subscription documents exceeds the 25MB limit allowed by DocuSign. Please contact your manager to reduce the size of subscription documents.";
export const EMAIL_RESERVED_UI_ERROR_MESSAGE =
  "The domain of the entered email has restrictions. Please contact your organization's DocuSign account administrator to check your DocuSign domain settings. This is typically your IT team.";
export const INVALID_RECIPIENT_UI_ERROR_MESSAGE =
  "Invalid recipient, please confirm your email. If the issue persists, please contact the manager.";

export const ERROR_CODE_TO_UI_ERROR_MESSAGE_MAP = {
  [ERROR_CODE_REQUEST_TOO_LARGE]: FILE_TOO_LARGE_UI_ERROR_MESSAGE,
  [ERROR_CODE_EMAIL_RESERVED]: EMAIL_RESERVED_UI_ERROR_MESSAGE,
  [ERROR_CODE_INVALID_RECIPIENT]: INVALID_RECIPIENT_UI_ERROR_MESSAGE,
};
